var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"cmpbk black--text",attrs:{"id":"home-container"}},[_c('h4',{staticClass:"white--text"},[_vm._v(" Thank you for your payment. Your transaction has been completed, and a receipt for your purchase may have been emailed to you. Log into your PayPal account or card provider to view transaction details. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }